import React from "react";
import swellchart from "../static/swellchart.jpg"
import westport from "../static/westport.jpg"
//import wave from "../static/icons/wave.svg"
import NavbarDesktop from "./NavbarDesktop";
import NavbarMobile from "./NavbarMobile";

function Home() {
	return(
		<div>
			<NavbarDesktop />
			<NavbarMobile />
			<div className="content">
				<div className="pb-8 text-center">
					<h1 className="text-bold">Welcome to Surf Journal!</h1>

					<p className="font-bold text-s sm:text-xl md:text-2xl w-10/12 mx-auto">
						This is a platform to document swell data from your favorite breaks.
						Want to remember the conditions from that day you scored? Here you can save swell data from buoys 
						to always have record of your best (or worst) days
					</p>
					{/* <object data={wave} alt="wave" className="wave">wave</object> */}
				</div>

				<img src={swellchart} alt="swellchart" className="home-img"/>

				<div className="pb-8 my-6">
					<h2>Track All of Your Sessions</h2>
					<p className="mt-8 font-bold text-s sm:text-xl md:text-2xl w-10/12 mx-auto">
						Surf Journal takes buoy data from the <a href="https://www.ndbc.noaa.gov/" className="text-blue-400 underline">National Buoy Data
						Center</a> and extracts the time from your session. You can then see all the swell data from your time 
						in the water. <br></br>This information can be used to track when your break is good or what swells to avoid.
					</p>
				</div>

				<img src={westport} alt="westport" className="home-img"/>
			</div>
		</div>
	)
}

export default Home